export enum C3GraphicResourceKind {
    OriginalEps = 'OriginalEps',
    DerivedPdf = 'DerivedPdf',
    DerivedSvg = 'DerivedSvg',
    PreviewPng = 'PreviewPng',
    ThumbnailPng = 'ThumbnailPng',
}

export enum C3GraphicResourceStatus {
    Pending = 'Pending',
    Uploaded = 'Uploaded',
    Validating = 'Validating',
    Converting = 'Converting',
    Ready = 'Ready',
    NeedsReview = 'NeedsReview',
    Failed = 'Failed',
    Rejected = 'Rejected',
}
